import { actionArrType, columnType } from "DataTypes/Table";
import { ControlledTable } from "Components";
import { Filter2DataProps } from "DataTypes/Common";
import { TaskPriorityArr } from "Constant/Arr";
import { TaskListType } from "DataTypes/Services/Tasks";
import FilterData from "Components/Filter2/Data";
import { DropdownArrPropsType } from "DataTypes/Form";

export const actionArr: (
  handleView: () => void,
  handleEdit: () => void,
  rowData: TaskListType
) => actionArrType[] = (handleView, handleEdit, rowData) => {
  return [
    ControlledTable.ActionData.viewTitleAction(handleView),
    ...(rowData?.status != "Close" && rowData?.status != "Completed"
      ? [ControlledTable.ActionData.editAction({ handleClick: handleEdit })]
      : []),
  ];
};

export const TableCol: columnType[] = [
  ControlledTable.ColumnData.ExclaimationCol("3%"),
  ControlledTable.ColumnData.DateTimeCol1("12%"),
  ControlledTable.ColumnData.TaskTypeCol("9%"),
  ControlledTable.ColumnData.StatusCol("9%"),
  ControlledTable.ColumnData.PriorityCol("9%"),
  ControlledTable.ColumnData.SourceCol("9%"),
  ControlledTable.ColumnData.CreatedByCol("10%"),
  ControlledTable.ColumnData.PatientCol("10%"),
  ControlledTable.ColumnData.SubjectCol("10%"),
  ControlledTable.ColumnData.NoteCol("10%"),
  ControlledTable.ColumnData.ActionCol("9%"),
];

export const FilterArr = (
  TypeArr: DropdownArrPropsType[],
  taskStatusList: DropdownArrPropsType[],
): Filter2DataProps[] => {
  return [
    FilterData.taskDate,
    { ...FilterData.taskType, dropArr: TypeArr },
    { ...FilterData.taskStatus, dropArr: taskStatusList },
    { ...FilterData.taskPriority, dropArr: TaskPriorityArr },
    FilterData.taskCreatedBy,
    FilterData.taskCreatedByDesig,
    FilterData.patientTask,
  ];
};
